import { createSlice } from '@reduxjs/toolkit';

const initialUserData = {
  isLogged: false,
  perfil: '',
  token: '',
  id: '',
  email: '',
  hasSignature: false,
  hasCompany: false,
  companyType: null,
  existsProcessOpenCompany: false,
  segmentoAtuacao: '',
  novoRegistro: false,
};

export const userSlice = createSlice({
  name: 'user',
  initialState: initialUserData,
  reducers: {
    login: (state, action) => {
      state.isLogged = true;
      state.perfil = action.payload.perfil;
      state.token = action.payload.token;
      state.id = action.payload.id;
      state.nome = action.payload.nome;
      state.email = action.payload.email;
      state.hasSignature = action.payload.hasSignature;
      state.hasCompany = action.payload.hasCompany;
      state.companyType = action.payload.companyType;
      state.existsProcessOpenCompany = action.payload.existsProcessOpenCompany;
      state.segmentoAtuacao = action.payload.segmentoAtuacao;
      state.novoRegistro = action.payload.novoRegistro;
    },
    logout: (state) => {
      state.isLogged = false;
      state.perfil = '';
      state.token = '';
      state.id = '';
      state.nome = '';
      state.email = '';
      state.hasSignature = false;
      state.hasCompany = false;
      state.companyType = null;
      state.existsProcessOpenCompany = false;
      state.segmentoAtuacao = '';
      state.novoRegistro = false;
    },
    update: (state, action) => {
      state = {
        ...state.data,
        ...action.payload,
      };
    },
  },
});

export const { login, logout, update } = userSlice.actions;

export default userSlice.reducer;
